export class HttpTimeoutError extends Error {
  constructor(_timeoutInMilliseconds: number) {
    super(`HTTP request timed out after ${_timeoutInMilliseconds} milliseconds.`);
    this.name = 'HttpTimeoutError';
  }
}
